import React from 'react'
import SafeFilePreviewWithErrorBoundary from '../SafeFilePreview/SafeFilePreview'
import SafeOfficePreviewWithErrorBoundary from '../SafeOfficePreview/SafeOfficePreview'
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'
import {
  sanitizeFileObject,
  getFileTypeFromName,
} from '../../../../../utils/fileUtils/safeFileOperations'

export const FilePreviewPane = ({ file }) => {
  try {
    // Sanitize file object
    const safeFile = file
    const fileType = getFileTypeFromName(safeFile?.name)

    if (!safeFile) {
      return (
        <ErrorBoundary>
          <div className="flex flex-col items-center justify-center h-32 p-4">
            <div className="text-4xl mb-2">⚠️</div>
            <p className="text-gray-600 text-sm">No valid file selected</p>
          </div>
        </ErrorBoundary>
      )
    }

    // Use Office preview for Office documents
    if (
      ['document', 'spreadsheet', 'presentation'].includes(fileType) &&
      safeFile.previewLink
    ) {
      return (
        <ErrorBoundary>
          <div className="h-48">
            {' '}
            {/* Fixed height for preview pane */}
            <SafeOfficePreviewWithErrorBoundary
              file={safeFile}
              fileType={fileType}
            />
          </div>
        </ErrorBoundary>
      )
    }

    // Use general file preview for other types
    return (
      <ErrorBoundary>
        <SafeFilePreviewWithErrorBoundary file={safeFile} />
      </ErrorBoundary>
    )
  } catch (error) {
    console.error('Error in FilePreviewPane:', error)
    return (
      <ErrorBoundary>
        <div className="flex flex-col items-center justify-center h-32 p-4">
          <div className="text-4xl mb-2">⚠️</div>
          <p className="text-gray-600 text-sm">Error loading preview</p>
        </div>
      </ErrorBoundary>
    )
  }
}
